/**
 * Environment Configuration
 * Centralized configuration for the frontend application
 */

export const config = {
  // API Configuration
  api: {
    baseUrl: import.meta.env.VITE_API_BASE_URL || 'http://localhost:4000',
    socketUrl: import.meta.env.VITE_SOCKET_URL || 'http://localhost:4000',
  },

  // Team Configuration
  team: {
    id: import.meta.env.VITE_TEAM_ID || '0153c23c-7b1b-4578-8a6f-e36c3bcc2a36',
    code: import.meta.env.VITE_TEAM_CODE || 'ws',
  },

  // Dashboard Configuration
  dashboard: {
    appName: import.meta.env.VITE_APP_NAME || 'MNX Analytics',
  },

  // Feature Flags
  features: {
    enableUserDetails: import.meta.env.VITE_ENABLE_USER_DETAILS === 'true',
  },
} as const;

export default config;
